import {
  CurrentPayPlan,
  RoleType,
  MembershipLevel,
  MSSMemberStatus,
  MembershipProductType,
  GenderType,
} from '@ace-clublabs/common-membership-api-types';
import { IState, IMemberDetails } from './model';
import { IneligibityReasonCode, MSSProductStatus } from '@lib/types';
import { requestPlasticCardResponseStub } from '../api/stubs';

export const membershipDetailsStateStub: IMemberDetails = {
  sessionId: 'some-session-id',
  clubCode: '004',
  loggedInCustomerId: '12345678',
  selectedCustomerId: undefined,
  clubRegion: undefined,
  joinYear: '2015',
  longevity: '5',
  renewexpiredate: '05/05/2026',
  members: [
    {
      customerId: '12345678',
      firstName: 'Janet',
      middleName: 'A',
      lastName: 'Morales',
      nameSuffix: 'Sr',
      roleType: RoleType.PRIMARY,
      status: MSSMemberStatus.EXISTING,
      plasticReplacementCard: { eligible: true, ineligibityReasonCode: null },
      rules: {
        viewMembership: true,
        changeMembership: true,
        makePayment: true,
        updateEmail: true,
        updatePhone: true,
        nameChange: {
          firstName: true,
          middleName: true,
          lastName: true,
          suffix: true,
        },
      },
      residenceAddress: {
        addressLine1: '123 Main St',
        addressLine2: 'Apartment 1',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90007',
      },
      mailingAddress: {
        addressLine1: '456 Main St',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90007',
      },
    },
    {
      customerId: '11111111',
      firstName: 'James',
      lastName: 'Morales',
      emailAddress: 'jmorales@email.com',
      roleType: RoleType.ADULT_ASSOCIATE,
      status: MSSMemberStatus.EXISTING,
      plasticReplacementCard: { eligible: true, ineligibityReasonCode: null },
      rules: {
        viewMembership: true,
        changeMembership: true,
        makePayment: true,
        updateEmail: true,
        updatePhone: true,
        nameChange: {
          firstName: true,
          middleName: true,
          lastName: true,
          suffix: true,
        },
      },
      residenceAddress: {
        addressLine1: '123 Main St',
        addressLine2: 'Apartment 1',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90007',
      },
      mailingAddress: {
        addressLine1: '456 Main St',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90007',
      },
    },
    {
      customerId: '22222222',
      firstName: 'Joe',
      lastName: 'Morales',
      middleName: 'A',
      nameSuffix: 'Jr.', //confirm what format suffix is returned from api
      roleType: RoleType.DEPENDENT,
      status: MSSMemberStatus.EXISTING,
      plasticReplacementCard: { eligible: true, ineligibityReasonCode: null },
      rules: {
        viewMembership: false,
        changeMembership: false,
        makePayment: false,
        updateEmail: true,
        updatePhone: true,
        nameChange: {
          firstName: true,
          middleName: true,
          lastName: true,
          suffix: true,
        },
      },
      residenceAddress: {
        addressLine1: '123 Main St',
        addressLine2: 'Apartment 1',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90007',
      },
      mailingAddress: {
        addressLine1: '456 Main St',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90007',
      },
    },
  ],
  benefitLevels: {
    existingLevel: MembershipLevel.CLASSIC,
    pendingLevel: MembershipLevel.CLASSIC,
    effectiveDate: '6/24/2024',
  },
  products: [
    {
      type: MembershipProductType.RV,
      status: MSSProductStatus.EXISTING,
      effectiveDate: '06-30-2024',
    },
  ],
  inArrears: 'N',
  inRenewal: 'N',
};

export const mockState: IState = {
  memberDetails: membershipDetailsStateStub,
  confirmation: requestPlasticCardResponseStub.data,
  loading: { priceCart: false },
  tags: undefined,
  isMobileApp: false,
};

export const initialState: IState = {
  memberDetails: {
    sessionId: '',
    clubCode: undefined,
    loggedInCustomerId: undefined,
    selectedCustomerId: undefined,
    clubRegion: undefined,
    joinYear: undefined,
    members: undefined,
    benefitLevels: undefined,
    products: undefined,
    renewexpiredate: undefined,
    inArrears: undefined,
    inRenewal: undefined,
    longevity: undefined,
  },
  confirmation: { CustomerId: '', MembershipNumber: '', ClubCode: '' },
  loading: { priceCart: false },
  tags: undefined,
  isMobileApp: undefined,
};
